import { createContext, useContext, useEffect, useState, useCallback } from 'react';
import { fetchApi } from '../services/api';
const AuthContext = createContext(null);
export const AuthProvider = ({ children }) => {
	const [user, setUser] = useState(null);
	const [loading, setLoading] = useState(true);
	const [beVersion, setBeVersion] = useState(null);
	const [cardData, setCardData] = useState(null);
	/**
	 * Load authenticated user
	 * Backend handles access/refresh automatically
	 */
	const loadUser = useCallback(async () => {
		try {
			const res = await fetchApi('/me', 'get');
			getBackendVersion();
			if (res?.authenticated) {
				setUser(res.user);
			} else {
				setUser(null);
			}
		} catch (err) {
			setUser(null);
			// setIsAccessDenied(true);
		} finally {
			setLoading(false);
		}
	}, []);
	const getBackendVersion = () => {
		fetchApi("/version", "get")
			.then((res) => {
				if (res && res.code && res.code === 200) {
					if (res.data) {
						setBeVersion(res.data.be_build);
						if (res.data?.card_data) {
							setCardData(res.data.card_data);
						}
					}
				} else {
					setBeVersion(null);
				}
			});
	};
	/**
	 * On app boot / refresh
	 */
	useEffect(() => {
		loadUser();
	}, [loadUser]);
	/**
	 * After successful login
	 */
	const login = async () => {
		await loadUser();
		return true;
	};
	/**
	 * clear user data on logout
	 */
	const clearUserData = () => {
		setUser(null);       // Clear auth state
		sessionStorage.clear();
		localStorage.clear();
	};
	return (
		<AuthContext.Provider
			value={{
				user,
				loading,
				login,
				clearUserData,
				beVersion,
				cardData,
			}}
		>
			{children}
		</AuthContext.Provider>
	);
};
/**
 * Hook
 */
export const useAuth = () => {
	const ctx = useContext(AuthContext);
	if (!ctx) {
		throw new Error('useAuth must be used inside AuthProvider');
	}
	return ctx;
};
